<template>
  <flex-layout wrap>
    <base-text class="col-3 col-md-3" color="primary" size="md">担当店舗</base-text>
    <screen-loader v-if="loading"/>
    <base-text v-else-if="!props.items.length" class="col-9 col-md-6" color="error" bold>該当店舗が見つかりませんでした</base-text>
    <flex-layout v-else class="col-12 col-md-9 d-flex pa-0" wrap>
      <base-text v-if="isAnySelected" justify="center" color="error" bold>{{ form.error.value }}</base-text>
      <div v-for="(shopEstateStatistic, i) in props.items" class="col-12 d-flex pa-0" :key="i">
        <base-checkbox
          v-if="!readonly"
          :model-value="isSelected(shopEstateStatistic)"
          class="col-1 pa-0"
          @update:modelValue="toggleModelValue(shopEstateStatistic)"
        />
        <div class="col-11 text-left ps-4">
          <base-text bold>{{ shopEstateStatistic.shopName }}</base-text>

          <base-text size="xs" bold v-if="shopEstateStatistic.total > 0">
             <span class="d-inline-block">{{'[ 新築一戸建て: '}}<span class="text-error">{{ shopEstateStatistic.newEstateCount }}</span>{{'件 '}}</span>
             <span class="d-inline-block">{{'中古一戸建て: '}}<span class="text-error">{{ shopEstateStatistic.oldEstateCount }}</span>{{'件 '}}</span>
             <span class="d-inline-block">{{'新築マンション: '}}<span class="text-error">{{ shopEstateStatistic.newMansionCount }}</span>{{'件 '}}</span>
             <span class="d-inline-block">{{'中古マンション: '}}<span class="text-error">{{ shopEstateStatistic.oldMansionCount }}</span>{{'件 '}}</span>
             <span class="d-inline-block">{{'土地: '}}<span class="text-error">{{ shopEstateStatistic.landCount }}</span>{{'件 '}}</span>
             <span class="d-inline-block">{{'事業用: '}}<span class="text-error">{{ shopEstateStatistic.businessCount }}</span>{{'件 ]'}}</span>
          </base-text>
          <base-text v-else>{{ shopEstateStatistic.fullAddress }}</base-text>
          <br/>
        </div>
      </div>
    </flex-layout>
  </flex-layout>
</template>
<script setup lang="ts">

import BaseText from "@/components/Texts/BaseText.vue";
import FlexLayout from "@/components/Layouts/FlexLayout.vue";
import BaseCheckbox from "@/components/Forms/BaseCheckbox.vue";
import {computed, toRef, watch } from "vue";
import {EstateCount} from "@/services/http/fcShop.donetwork.http";
import useFormField from "@/composable/ui/useFormField";
import ScreenLoader from "@/components/Loaders/ScreenLoader.vue";

const props = defineProps<{
    modelValue: EstateCount[],
    items: EstateCount[],
    readonly?: boolean,
    loading?: boolean,
    defaultStoreId?: number | null
}>();

const emit = defineEmits({
    'update:modelValue': (value: EstateCount[]) => true
});

const form = useFormField(
    toRef(() => props.modelValue),
    toRef(() =>  [(value: EstateCount[]) => value.length > 0 ? true : '1店舗以上選択してください']),
);

const isAnySelected = computed(() => !props.modelValue.length && props.items.length);

function isSelected(item: EstateCount) {
    return props.modelValue.some((modelValue) => modelValue.shopId === item.shopId);
}

function toggleModelValue(item: EstateCount) {
    const items = [...props.modelValue];
    const value = items.find((modelValue) => modelValue.shopId === item.shopId);
    value ? items.splice(items.indexOf(item), 1) : items.push(item);
    emit('update:modelValue', items)
}

watch(() => [props.defaultStoreId, props.items], ([defaultStoreId, items]) => {
    if (defaultStoreId && items) {
      const items = [...props.items];
      const defaultItem = items.find(item => item.shopId === defaultStoreId);
        if (defaultItem) {
            emit('update:modelValue', [defaultItem]);
            return;
        }
    }
    emit('update:modelValue', []);
}, { immediate: true });


</script>


<style scoped>

</style>
